module.exports = __webpack_public_path__ + "e62c32db118d23c7b4605cf69290beee.svg";